__turbopack_context__.v({
  "card": "Quiz-module-scss-module__n61oua__card",
  "card-stack": "Quiz-module-scss-module__n61oua__card-stack",
  "content": "Quiz-module-scss-module__n61oua__content",
  "cta-group": "Quiz-module-scss-module__n61oua__cta-group",
  "informative": "Quiz-module-scss-module__n61oua__informative",
  "input": "Quiz-module-scss-module__n61oua__input",
  "link": "Quiz-module-scss-module__n61oua__link",
  "negative": "Quiz-module-scss-module__n61oua__negative",
  "positive": "Quiz-module-scss-module__n61oua__positive",
  "refresh": "Quiz-module-scss-module__n61oua__refresh",
  "result": "Quiz-module-scss-module__n61oua__result",
  "result-title": "Quiz-module-scss-module__n61oua__result-title",
});
